import Vue from 'vue'
import Vuex from 'vuex'

import loader from './modules/loader'
import socket from './modules/socket'
import i18n from './modules/i18n'
import user from './modules/user'
import reports from './modules/reports'
import donationTypes from './modules/donation-details'
import email from './modules/email'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    loader,
    socket,
    user,
    reports,
    donationTypes,
    i18n,
    email
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js